export const questions = [
	{
		enabled: true,
		title: `<h3>What scripts do you have available?</h3>`,
		answer: `
			We constantly test & revise our real estate scripts to give you the highest performing agents.
			<br/><br/>
			See an overview of our newest scripts <a href="https://docs.google.com/document/d/1eZrsIm0fQLcGYNWdIeGvwEXgEebW9MzwT4suXSYVYZ0/edit?tab=t.0">here</a>. 
		`,
	},
	{
		enabled: true,
		title: `<h3>How do I make Gen refer to specific information?</h3>`,
		answer: `
			Use [regular brackets] to add instructions: (E.g. "We can definitely help you with [recap what human said]")
			<br/><br/>
			Use {{double curly brackets}} to insert variables into Gen's advice:
			<ul>
				<li>AI's first name: {{agent_name}}</li>
				<li>Follow up caller: {{follow_up_caller}}</li>
				<li>Follow up company: {{company_name}}</li>
				<li>Prospect's first name: {{name}}</li>
				<li>Prospect's address: {{address}}</li>
			</ul>
	`,
	},
	{
		enabled: true,
		title: `<h3>How do I change what Gen says?</h3>`,
		answer: `
			At this time, any advice you type in the Advice to AI section competes with the underlying advice from the script type you select. Below are some prompts to override her underlying prompt. We recommend doing this sparingly (< 2000 words) to avoid confusing your agent. 
			<br/><br/>
			Interested in being a beta tester and building scripts from scratch? Email us at <a href="mailto:info@prop.ai">info@prop.ai</a>
			<br/><br/>
			<b>If...then</b>
			<br/>
			<i>Examples:</i>
			<br/>
			If the customer responds to your opening question "Would that be you?" positively, implying that they are the owner of {{address}}:
			<br/>
			Say "So I’m an assistant with {{company name}} and we actually offer a no-cost consultation to help homeowners save their homes. Have you had a chance to explore all your options for saving your home from foreclosure?”
			<br/><br/>
			If the customer responds to your question "Would that be you" by saying "no," implying that they are NOT the owner of {{address}}:
			<br/>
			Say "Got it! Do you think {{name}} would be open to a no cost follow-up call about 5 ways to avoid foreclosure?" 
			<br/><br/>
			<b>Don't say... say... instead</b>
			<br/>
			<i>Examples:</i>
			<br/>
			If the customer responds to your opening question ""Would that be you?"" by asking you a question (using words like "who" "calling" "ask"" or "why"):
			<br/>
			Do NOT say that you are an investment firm looking to buy properties. Instead, say: “My teammate {{follow_up_caller}} and I are with {{company name}}: a small investing group. Our goal is to help homeowners understand they have options for saving their homes. Every time we preVENT a foreclosure we count that as a win! Even if the end result doesn't make us money.”
			<br/><br/>
			<b>Pause for response</b>
			<br/>
			<i>Examples:</i>
			<br/>
			If the customer says “No” to your question about whether they would like to speak with {{follow_up_caller}}, OR the customer indicates that they do not want to talk again:
			Say “I understand. I’ve added you to our Do Not Call list. If you change your mind down the road, you can always reach us at {{type your call back number here}}. Thank you for your time, and have a great day!” Pause for response and then hang up the phone. 
			<br/><br/>
			<b>If you ever feel confused about what to say, say</b>
			<br/>
			<i>Examples:</i>
			<br/>
			If a customer ever responds to something you say in a way that leaves you unsure about how to follow up:
			<br/>
			Say in a friendly way: “Well, I guess, I don’t want to take up any more of your time today than I already have?? I’m sure you have a lot on your plate right now! But I would like to let my colleague {{follow_up_caller}} follow-up soon to make sure you have all the information you need. How does that sound?”
		`,
	},
	{
		enabled: true,
		title: `<h3>How do I change how Gen sounds?</h3>`,
		answer: `
			At this time Prop AI only uses a female voice for Gen because we think that voice sounds the most lifelike. You can still change Gen's inflection and speed with custom advice, however.
			<br/><br/>
			<b>Tone:</b>
			<ul>
				<li>Use all caps for emphasis or enthusiasm. ("If caller says "yes," say: "I would LOVE to set up a brief follow-up call with my teammate, {{partner_name}}.")</li>
				<li>Add exclamation points for enthusiasm ("Hi, my name is {{agent_name}}!")</li>
				<li>Double question marks for optimism ("How does that sound??")</li>
			</ul>
			<b>Speed:</b>
			<ul>
				<li>Add commas for small pauses: ("HI, are you the listing agent?")</li>
				<li>Add colons, exclamation points, or periods for bigger pauses ("I'm with {{company name}}: a small investing team looking to by a house in this area.").</li>
			</ul>
			<b>Pronunciation:</b>
			<ul>
				<li>Use phonetic spellings and caps for words Gen doesn't pronounce correctly on test calls (e.g. Subject TOO, TEH-ris)</li>
			</ul>
		`,
	},
	{
		enabled: true,
		title: `<h3>How do I make sure Gen runs smoothly?</h3>`,
		answer: `
			Gen might delay if you have too much custom advice competing with her underlying script. We recommend using prompts without much modification since we know how well those perform. If you still want to input advice:
			<br/><br/>
			<ol style="margin: auto">
				<li>Consult our <a href="https://docs.google.com/spreadsheets/d/1BnCDci3vdDc4qPWNKbnpPWQJWVNj3W79wUU2lInGpFs/edit?pli=1&gid=778108396#gid=778108396">user library</a> for ideas</li>
				<li>Be clear</li>
				<li>Be concise (no more than 2000 words)</li>
				<li>Test, test, test</li>
			</ol>
		`,
	},
	{
		enabled: true,
		title: `<h3>Why did Gen’s test call show up as ‘Spam likely’?</h3>`,
		answer: `
			We periodically retire phone numbers so that our calls don't get flagged as Spam.
			<br/><br/>
			You may sometimes still see a 'Spam' or 'Scam Likely' notice on test calls. Since Gen uses local numbers to contact prospects, this won’t necessarily affect your other calls.
			<br/><br/>
			If your answered call rate is ever lower than 10% on a large sample, we may need to refresh our numbers. Contact <a href="mailto:info@prop.ai">info@prop.ai</a> to let us know.
		`,
	},
	{
		enabled: false,
		title: `<h3>Why does Gen sound slow in test calls?</h3>`,
		answer: `
			Gen may sound slower in test calls because those force themselves upon the servers and jump the queue, whereas regular campaigns wait their turn. 
			<br/><br/>
			If you ever suspect that latency affected your campaign, however, please <a href="https://app.tango.us/app/workflow/Emailing-Campaign-CSV-to-Prop-support-08963ae5256f4885afdddc22f221ed3c">export</a> the campaign’s CSV and email to <a href="mailto:info@prop.ai">info@prop.ai</a> so we can investigate and restore your call quota as needed.`,
	},
	{
		enabled: true,
		title: `<h3>Why didn’t Gen call me?</h3>`,
		answer: `
			If a campaign call does not go through to your own number:
			<ul>
				<li>Verify if you are on the Do Not Call registry, at <a href="https://www.donotcall.gov/">https://www.donotcall.gov/<a></li>
			</ul>
			If a test call does not go through to your number:
			<ul>
				<li>For iPhone, go to Settings > Phone > Call Blocking & Identification, then turn off 'Business Call Identification.</li>
				<li>Try closing out your web browser and refreshing.</li>
			</ul>

			If these steps don't fix your issue, please contact us at <a href="mailto:info@prop.ai">info@prop.ai<a>
		`,
	},
]
